import { GET_DEVICE_MANAGEMENT_DATA } from "../../constants/api";
import { DeviceManagementData } from "../../types/dataType";
import axios from "../fetch/fetch";

export const getDeviceManagementAPI = async (): Promise<DeviceManagementData[]> => {
  const response = await axios.get(GET_DEVICE_MANAGEMENT_DATA);
  return response.data;
};
